import React from "react";

const StarOutlinedIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2639_8012)">
        <path
          d="M5.60044 1.21402C5.72882 0.950969 5.793 0.819444 5.88014 0.777421C5.95596 0.74086 6.04404 0.74086 6.11986 0.777421C6.207 0.819444 6.27118 0.950969 6.39956 1.21402L7.6175 3.70965C7.6554 3.78731 7.67435 3.82614 7.70204 3.85629C7.72656 3.88298 7.75597 3.90461 7.78864 3.91997C7.82553 3.93733 7.86789 3.94359 7.95262 3.95611L10.677 4.35887C10.9638 4.40128 11.1073 4.42249 11.1737 4.49336C11.2314 4.55502 11.2586 4.63975 11.2476 4.72396C11.235 4.82075 11.1311 4.92305 10.9234 5.12767L8.9528 7.069C8.89137 7.12951 8.86066 7.15977 8.84084 7.19578C8.82329 7.22765 8.81203 7.26268 8.80769 7.2989C8.80278 7.3398 8.81003 7.38255 8.82453 7.46803L9.2895 10.2101C9.33855 10.4993 9.36307 10.6439 9.31698 10.7297C9.27689 10.8044 9.20562 10.8567 9.12302 10.8722C9.02809 10.89 8.89971 10.8217 8.64293 10.6852L6.2074 9.38968C6.13151 9.34932 6.09357 9.32913 6.0536 9.3212C6.0182 9.31418 5.9818 9.31418 5.9464 9.3212C5.90643 9.32913 5.86849 9.34932 5.7926 9.38968L3.35707 10.6852C3.1003 10.8217 2.97191 10.89 2.87698 10.8722C2.79438 10.8567 2.72311 10.8044 2.68302 10.7297C2.63693 10.6439 2.66145 10.4993 2.7105 10.2101L3.17547 7.46803C3.18997 7.38255 3.19722 7.3398 3.19231 7.2989C3.18797 7.26268 3.17671 7.22765 3.15916 7.19578C3.13934 7.15977 3.10863 7.12951 3.0472 7.069L1.07658 5.12766C0.868885 4.92305 0.765036 4.82075 0.752399 4.72396C0.741404 4.63975 0.768567 4.55502 0.826324 4.49336C0.892708 4.42249 1.03615 4.40128 1.32304 4.35887L4.04738 3.95611C4.13211 3.94359 4.17447 3.93733 4.21136 3.91997C4.24403 3.90461 4.27344 3.88298 4.29796 3.85629C4.32565 3.82614 4.3446 3.78731 4.3825 3.70965L5.60044 1.21402Z"
          stroke="#A5A3AE"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2639_8012">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StarOutlinedIcon;
